// src/api/axiosConfig.js
import axios from 'axios';



const api = axios.create({
  // Dev: REACT_APP_API_URL comes from .env.development (http://localhost:8000).
  // Prod builds: unset, so URLs are relative and nginx proxies /api/ to Django.
  baseURL: `${process.env.REACT_APP_API_URL || ''}/api/`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});


// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    // FIXED: Use 'access_token' (with underscore) to match AuthContext
    const token = localStorage.getItem('access_token');
    console.log('Token from localStorage (access_token):', token ? 'exists' : 'not found');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Authorization header set for:', config.url);
    } else {
      console.log('No token found for request to:', config.url);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// On a 401, refresh the access token once and retry the original request —
// covers requests fired after a long idle period (e.g. editing the ERP import
// preview for a while) where the access token expired between AuthContext's
// periodic refreshes.
let refreshPromise = null;
const refreshAccessToken = () => {
  if (!refreshPromise) {
    const refresh = localStorage.getItem('refresh_token');
    refreshPromise = axios
      .post(`${process.env.REACT_APP_API_URL || ''}/api/token/refresh/`, { refresh })
      .then((res) => {
        localStorage.setItem('access_token', res.data.access);
        return res.data.access;
      })
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
};

// Response interceptor for debugging
api.interceptors.response.use(
  (response) => {
    console.log('Response success:', response.config.url, response.status);
    return response;
  },
  async (error) => {
    console.log('Response error:', error.config?.url, error.response?.status);

    const { config, response } = error;
    if (response?.status === 401 && !config._retried && localStorage.getItem('refresh_token')) {
      config._retried = true;
      try {
        const newToken = await refreshAccessToken();
        config.headers.Authorization = `Bearer ${newToken}`;
        return api(config);
      } catch (refreshError) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;